import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { ITipoFormulario } from '../model/tipo_formulario.model';

@Injectable()
export class TipoFormularioService extends EntityService<ITipoFormulario> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'tipo_formulario',
      pluralBaseEntityEndPoint: 'tipos_formulario'
    });
  }
}
